
import {
	SET_CLIENTS,
	SET_CLIENT,
	SET_META,
	SET_ORDERS_META,
	SET_CLIENT_ORDERS,
	SET_CLIENT_ORDERS_META,
	SET_CLIENT_ORDERS_OLD,
	SET_CLIENT_ORDERS_OLD_META,
	SET_CLIENT_ORDERS_PRODUCTS_META,
	UPDATE_CLIENT_FORM,
	CLEAR_CLIENT_FORM,
	SET_LOADING,
	SET_SEARCH_FILTERS,
	SET_ORDERS_SEARCH_FILTERS,
	SET_CLIENTS_STATISTICS,
	SET_CLIENT_STATISTICS

} from './mutation-types'

export default {
	[SET_LOADING] (state, loading) {
		state.loading = { ...state.loading, ...loading }
	},
	[SET_CLIENTS] (state, clients) {
		if (!clients || !clients.length) {
			state.meta = {}
		}
		state.clients = clients
	},
	[SET_CLIENTS_STATISTICS] (state, data) {
		state.clientsStatistics = data
	},
	[SET_CLIENT_STATISTICS] (state, data) {
		state.clientStatistics = data
	},
	[SET_CLIENT] (state, client) {
		state.client = client
	},
	[SET_META] (state, meta) {
		state.meta = meta
	},
	[SET_CLIENT_ORDERS_META] (state, meta) {
		state.clientOrdersMeta = meta
	},
	[SET_CLIENT_ORDERS_PRODUCTS_META] (state, meta) {
		state.clientOrdersProductsMeta = meta
	},
	[SET_CLIENT_ORDERS_OLD_META] (state, meta) {
		state.clientOrdersOldMeta = meta
	},

	[SET_ORDERS_META] (state, meta) {
		state.ordersMeta = meta
	},
	[SET_CLIENT_ORDERS] (state, orders) {
		state.orders = orders
	},
	[SET_CLIENT_ORDERS_OLD] (state, orders) {
		state.ordersOld = orders
	},
	[UPDATE_CLIENT_FORM] (state, data) {
		state.editClientForm = { ...state.editClientForm, ...data }
	},
	[CLEAR_CLIENT_FORM] (state) {
		state.editClientForm = {}
	},
	[SET_SEARCH_FILTERS] (state, filters) {
		state.searchFilters = filters
	},
	[SET_ORDERS_SEARCH_FILTERS] (state, filters) {
		state.ordersSearchFilters = filters
	}
}
